import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../assets/icons";

const ServerStatus = ({ simple = false }) => {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(false);

  const MS1URL = process.env.REACT_APP_API_URL;
  const BASE_URL = MS1URL || "/api";

  useEffect(() => {
    const checkServer = async () => {
      try {
        const res = await fetch(`${BASE_URL}/check_server_status`, {
          cache: "no-store",
        });

        if (!res.ok) {
          setIsOnline(false);
          return;
        }

        const data = await res.json();

        setIsOnline(data.status === "Server is running normally");
      } catch (error) {
        console.error("Server check failed:", error);
        setIsOnline(false);
      }
    };

    checkServer();

    const interval = setInterval(checkServer, 15000);

    return () => clearInterval(interval);
  }, [BASE_URL]);

  if (simple) {
    const label = `${isOnline ? "Server Online" : "Server Offline"} — view status page`;
    return (
      <button
        type="button"
        onClick={() => navigate("/status")}
        className={`flex items-center justify-center w-4 h-4 rounded-full ${
          isOnline ? "bg-green-500" : "bg-red-500"
        }`}
        aria-label={label}
        title={label}
      >
        <Icon icon={isOnline ? "Check" : "Warning"} className="w-2.5 h-2.5 text-white" />
      </button>
    );
  }

  return (
    <div
      style={{
        textAlign: "right",
        padding: "6px 16px",
        background: isOnline ? "#e8f5e9" : "#ffebee",
        color: isOnline ? "#2e7d32" : "#c62828",
        fontWeight: "500",
        borderBottom: "1px solid #ddd",
      }}
    >
      {isOnline ? "Server Online" : "Server Offline"}
    </div>
  );
};

export default ServerStatus;